import { IsNotEmpty, IsUUID } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class DeleteChapterTeachingDto {
  @ApiProperty({ description: 'ID du chapitre', type: 'string' })
  @IsNotEmpty()
  @IsUUID('4')
  chapterId!: string
}
